import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { AgreementPage } from '@/components/AgreementPage';
import { ContractDetails } from '@/components/ContractDetails';
import { ContractSearchPage } from '@/components/ContractSearchPage';
import { Layout } from '@/components/Layout';
import { RouteError } from '@/components/RouteError';
import { VinDetailsPage } from '@/components/VinDetailsPage';
import {
  agreementLoader,
  contractLoader,
  searchLoader,
  vinLoader,
} from '@/routes/loaders';

export const routeObjects: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    errorElement: <RouteError />,
    children: [
      {
        index: true,
        element: <ContractSearchPage />,
        loader: searchLoader,
        errorElement: <RouteError />,
      },
      {
        path: 'contracts/:contractId',
        element: <ContractDetails />,
        loader: contractLoader,
        errorElement: <RouteError />,
      },
      {
        path: 'agreements/:agreementId',
        element: <AgreementPage />,
        loader: agreementLoader,
        errorElement: <RouteError />,
      },
      {
        path: 'vin/:vin',
        element: <VinDetailsPage />,
        loader: vinLoader,
        errorElement: <RouteError />,
      },
    ],
  },
];

export const createRouter = () => createBrowserRouter(routeObjects);
